export const QueryParamName = {
  MenuId: "menuId",
};

export const MenuType = {
  PdfMenu: "pdfMenu",
  SimpleMenu: "simpleMenu",
};
